document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('search-module').addEventListener('click', function () {
        toggleSearch();
    });

    document.getElementById('close-search-module').addEventListener('click', function () {
        toggleSearch();
    });

    document.querySelector('#PageContainer').addEventListener('click', function (event) {
        const floatingSearchWrapper = document.getElementById('floating-search-wrapper');
        const isClickOutsideFloatingSearch = !floatingSearchWrapper.contains(event.target);

        if (isClickOutsideFloatingSearch && floatingSearchWrapper.classList.contains('active')) {
            floatingSearchWrapper.classList.remove('active');
            resetSearch();
        }
    });


    // document.getElementById('MobileNavTrigger').addEventListener('click', function () {
    //     if (document.getElementById('floating-search-wrapper').classList.contains('active')) {
    //         document.getElementById('floating-search-wrapper').classList.remove('active');
    //     }
    // });

    // document.getElementById('search-module-mobile').addEventListener('click', function () {
    //     const floatingSearchWrapper = document.getElementById('floating-search-wrapper');
    //     if (floatingSearchWrapper.classList.contains('active')) {
    //         floatingSearchWrapper.classList.remove('active');
    //     } else {
    //         floatingSearchWrapper.classList.add('active');
    //         document.getElementById('MobileNav').style.display = 'none';
    //     }
    // });

    function toggleSearch() {
        const floatingSearchWrapper = document.getElementById('floating-search-wrapper');
        if (floatingSearchWrapper.classList.contains('active')) {
            floatingSearchWrapper.classList.remove('active');
            resetSearch();
        } else {
            floatingSearchWrapper.classList.add('active');
        }
    }

    const predictiveSearchResults = document.querySelector('#search-module-result');

    async function performSearch(query) {
        await getSearchResults(query);
    }

    async function getSearchResults(searchTerm) {
        try {
            const response = await fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,article&resources[limit]=4&section_id=predictive-search`);

            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }

            const text = await response.text();
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            predictiveSearchResults.innerHTML = resultsMarkup;
            document.getElementById('predictive-search-view-all').addEventListener('click', function (event) {
                try {
                    if  (searchTerm) {
                        const query = searchTerm.replace(/ /g, '+').trim();
                        const url = `${window.location.origin}/search?q=${ query }`;
                        window.open(url);
                    }
                } catch (e) {
                    throw e;
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            const context = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }

    function resetSearch() {
        searchInput.value = '';
        predictiveSearchResults.innerHTML = '';
    }

    const searchInput = document.getElementById('searchInput');
    const debouncedSearch = debounce(function () {
        performSearch(searchInput.value);
        let viewAllBtn = document.getElementById('predictive-search-view-all');
        if (viewAllBtn) {
            viewAllBtn.value = searchInput.value;
        }
    }, 500);

    searchInput.addEventListener('input', debouncedSearch);
});
